var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component",class:_vm.cssClass,attrs:{"href":_vm.href,"target":_vm.target},on:{"click":_vm.click}},[(_vm.leftIcon)?_c('Icon',{class:_vm.$style.leftIcon,attrs:{"type":_vm.leftIcon}}):_vm._e(),_vm._t("default"),(_vm.rightIcon)?_c('Icon',{class:_vm.$style.rightIcon,attrs:{"type":_vm.rightIcon}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }